import React from 'react';
import { Navigate } from 'react-router-dom';

const NotFound = () => {
  return <Navigate to="/" />;
};

export default NotFound;
